import {styled} from "@mui/material/styles";
import { Card, CardMedia, Grid, Typography } from "@mui/material";
import { useColors } from "../../Context/ColorsContext"
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { MediaQuerys } from "../../styles/GlobalStyle";

const { tablet, desktop } = MediaQuerys;

export const Container = styled('div')(({modal, isThereImg}) => ({
    width: isThereImg ? 'fit-content' : '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    height: 'inherit',
    position: 'relative',
    borderRadius: '8px 8px 0 0',
    transition: 'width 2s',
    maxHeight: 'inherit',
    maxWidth: 'inherit',
    boxShadow: 'none',
    '&::-webkit-scrollbar': {
        width: 5,
        height: 5
    },
}))

export const CardBackground = styled(CardMedia)(({ theme }) => ({
    height: '100%', 
    backgroundSize: 'cover',
    objectFit: 'fill',
    position:'relative',
    width: '100%',
}))

export const IconArea = styled('div')(() => {
    const { colors } = useColors();
    return {
        background: colors.orange,
        color: colors.white,
        width: 30,
        height: 30,
        fontSize: 16,
        fontWeight: 'bold',
        borderRadius: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '2px solid #73480e',
        [desktop]: {
           height: 20,
           width: 20,
           fontSize: '0.80rem',
        }
    }
})

export const Area = styled('div')(({top, left, zIndex}) => {
    const { colors } = useColors();
    return {
        cursor: 'pointer',
        position: 'absolute',
        color: colors.white,
        top: `${top}%`,
        left: `${left}%`,
        zIndex: zIndex,
        transform: 'translate(-50%, -50%)'
    }
})

export const ArrowLeft = styled(KeyboardArrowLeftIcon)(({disabled}) => {
    const { colors } = useColors();
    return {
        color: disabled ? colors.white : '#c8d0dc',
        background: disabled ? colors.grayFont : '#647c9c',
        borderRadius: 20,
        cursor: disabled ? 'default' : 'pointer'
    }
})

export const ArrowsLeft = styled(KeyboardDoubleArrowLeftIcon)(({disabled}) => {
    const { colors } = useColors();
    return {
        color: disabled ? colors.white : '#c8d0dc',
        background: disabled ? colors.grayFont : '#647c9c',
        borderRadius: 20,
        cursor: disabled ? 'default' : 'pointer'
    }
})

export const GridContainer = styled(Grid)(() => {
    const { colors } = useColors();
    return {
        padding: '4px 10px 0px 10px',
        color: colors.grayFont
    }
})

export const GridCenter = styled(Grid)(({ theme }) => {
    const { colors } = useColors();
    return {
        textAlign: 'center',
        height: '100%',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'center',
        background: colors.white,
        borderRadius: '8px 8px 0 0',
    }
})

export const Title = styled(Typography)(() => {
    return {
        [desktop]: {
            fontSize: '0.75rem'
        },
        [tablet]: {
            fontSize: '0.75rem'
        }
    }
})

export const ContainerBottom = styled('div')(() => {
    return {
        display: 'flex',
        padding: '5px 10px 5px',
        justifyContent: 'space-between',
        alignItems: 'center',
		    borderTop: '1px solid #f8f8f8',
    }
})

export const ContainerGroup = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'row',
        gap: '2rem',
        [tablet]: {
            gap: '1rem',
        }
    }
})

export const ContainerLeft = styled('div')(() => {
    return {
        display: 'flex',
    }
})

export const ContainerRight = styled('div')(() => {
    return {
        display: 'flex',
    }
})

export const ContainerTypography = styled('div')(() => {
    return {
        display: 'flex',
    }
})

export const CustomCard = styled(Card)(() => {
    return {
        width: '100%',
        borderRadius: '0 0 8px 8px',
        boxShadow: 'none'
    }
})

export const GroupImage = styled(Card)(({ theme }) => {
    return {
		maxHeight: '430px',
		width: '100%',
		boxShadow: 'none',
    borderRadius: '8px 8px 0 0',
		'&::-webkit-scrollbar': {
			width: 5,
			height: 5
		},
		height: 'calc(100vh - 400px)',
		[theme.breakpoints.down('lg')]: {
			maxHeight: '320px',
		},
		'@media (max-height: 768px)': {
			height: 'calc(100vh - 350px)',
		},
    }
})

export const TitlePath = styled('span')(() => {
    return {
		color: '#a8a8a8'
    }
})

export const TextPath = styled('span')(() => {
    const { colors } = useColors();
    return {
		color: colors.buttonActionColor
    }
})